export default "__VITE_ASSET__CyrWG74Z__"